import {Country} from "../defs/country";
import {CountryGroup} from "../defs/group";

export const FederatedStatesofMicronesia: Country = {
    identifier: "FederatedStatesofMicronesia",
    name: "Federated States of Micronesia",
    countryCode: "FM",
    group: CountryGroup.OCEANIA,
    isUNMember: true,
    flag: "🇫🇲",
    svgPath: "m 862.59175,436.3134 -0.213,0.23 -0.014,-0.075 0.064,-0.138 0.09,-0.157 0.084,-0.094 0.109,-0.027 0.078,0.13 -0.088,0.113 -0.11,0.018 z m 38.557,5.831 -0.049,0.015 -0.022,-0.014 0.011,-0.072 0.016,-0.025 0.046,-0.002 0.08,0.02 0.006,0.018 -0.088,0.06 z m -0.656,0.241 -0.023,0.037 -0.171,-0.014 -0.024,-0.021 0.015,-0.016 0.082,-0.017 0.01,-0.051 -0.042,-0.011 0.036,-0.027 0.067,-0.005 0.038,0.032 0.021,0.046 -0.009,0.047 z m 18.711,1.496 -0.163,0.063 -0.205,-0.029 -0.063,-0.229 -0.094,-0.061 0.021,-0.113 0.144,-0.092 0.305,0.075 0.113,0.163 -0.072,0.108 0.014,0.115 z m 13.101,4.172 0.029,0.136 -0.179,-0.066 -0.024,-0.048 0.104,-0.048 0.07,0.026 z",
}
